import classnames from 'classnames';

export const totalNegativePercentage = value => classnames({
  'negative-total-percentage': value.startsWith('('),
});

export const negativePercentage = value => classnames({
  'negative-percentage': value.startsWith('('),
});
